

export enum PaymentTypes {
  CreditCard = 'creditCard',
  CashOnBoard = 'cashOnBoard',
  OpusCard = 'opusCard',
  Correspondance = 'correspondance',
  Free = 'free',
  OPUSCardMensuel = 'opusCardMensuel',
  OPUSCardPassage = 'opusCardPassage',
  CPOPassageSTL = 'cpoPassageSTL',
  CPOPassageEXO = 'cpoPassage',
  FreeZeroToEleven = 'freeZeroToEleven',
}

export interface ITab {
  value: PaymentTypes;
  label: string;
}
